if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getPooltimeSection() {
        return (
          this.closest('section[id^="MainProduct-"]') ||
          this.closest('.shopify-section') ||
          document
        );
      }

      getSelectedPooltimeAddons() {
        const scope = this.getPooltimeSection();

        return Array.from(
          scope.querySelectorAll(
            'input[data-pooltime-addon]:checked:not(:disabled)'
          )
        )
          .map((input) => ({
            variantId: input.dataset.variantId,
            title: input.dataset.addonTitle || '',
            priceCents: Number(input.dataset.priceCents || 0)
          }))
          .filter((addon) => addon.variantId);
      }

      async addPooltimeAddons(addons, quantity, parentVariantId) {
        let lastResponse = null;

        for (let index = 0; index < addons.length; index += 1) {
          const addon = addons[index];
          const isLast = index === addons.length - 1;

          const addonData = new FormData();
          addonData.append('id', addon.variantId);
          addonData.append('quantity', quantity);

          // Privata line-item properties. De börjar med "_" och är avsedda
          // för intern koppling mellan huvudprodukt och tillval.
          addonData.append('properties[_pooltime_addon]', 'true');
          addonData.append(
            'properties[_pooltime_parent_variant]',
            String(parentVariantId || '')
          );

          if (this.cart && isLast) {
            addonData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            addonData.append('sections_url', window.location.pathname);
          }

          const addonConfig = fetchConfig('javascript');
          addonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete addonConfig.headers['Content-Type'];
          addonConfig.body = addonData;

          const response = await fetch(
            `${routes.cart_add_url}`,
            addonConfig
          ).then((result) => result.json());

          if (response.status) {
            throw new Error(
              response.description ||
              response.message ||
              `Tillvalet "${addon.title || addon.variantId}" kunde inte läggas till.`
            );
          }

          lastResponse = response;
        }

        return lastResponse;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const selectedAddons = this.getSelectedPooltimeAddons();
        const parentVariantId = formData.get('id');
        const quantity = Math.max(
          1,
          parseInt(formData.get('quantity') || '1', 10) || 1
        );

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          const mainResponse = await fetch(
            `${routes.cart_add_url}`,
            config
          ).then((response) => response.json());

          if (mainResponse.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: parentVariantId,
              errors: mainResponse.errors || mainResponse.description,
              message: mainResponse.message
            });

            this.handleErrorMessage(mainResponse.description);

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message');

            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);

              const normalText = this.submitButton.querySelector('span');
              if (normalText) normalText.classList.add('hidden');

              soldOutMessage.classList.remove('hidden');
            }

            this.error = true;
            return;
          }

          let responseForCart = mainResponse;
          let addonErrorMessage = '';

          if (selectedAddons.length > 0) {
            try {
              const addonResponse = await this.addPooltimeAddons(
                selectedAddons,
                quantity,
                parentVariantId
              );

              if (addonResponse) {
                responseForCart = addonResponse;
              }
            } catch (addonError) {
              console.error('Pooltime add-on error:', addonError);

              addonErrorMessage =
                'Huvudprodukten lades i varukorgen, men ett tillval kunde inte läggas till. ' +
                'Kontrollera varukorgen och försök lägga till tillvalet igen.';
            }
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: parentVariantId
          });

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(responseForCart);
                });
              },
              { once: true }
            );

            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(responseForCart);
          }

          if (addonErrorMessage) {
            this.handleErrorMessage(addonErrorMessage);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) spinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
